import { useState, useEffect } from "react";
import * as FeatherIcon from "react-feather";

// ----------------------------
// ReviewSubmit Component
// ----------------------------
const ReviewSubmit = ({ onPrev, data }) => {
  const handleSubmit = () => {
    console.log("Submitting Data:", data);
    alert("Form submitted successfully!");
  };

  return (
    <div className="wizard_six">
      <h4 className="mb-3 custom_lable">Review and Final Approval</h4>
      <div className="blue_box">
        <h5 className="benchmark_head_blue">
          Benchmark Configuration Summary:
        </h5>
        <div className="bench_config_block">
          <h5 className="bench_config_head">Industry</h5>
          <div className="bench_config_list_block">
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>⚙️ Medical Distribution
                → 🔍 HealthTech / Healthcare Distribution
              </p>
            </div>
          </div>
        </div>

        <div className="bench_config_block">
          <h5 className="bench_config_head">Scope</h5>
          <div className="bench_config_list_block">
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>🌍 Global analysis
              </p>
            </div>
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>📌 Core product focus
              </p>
            </div>
          </div>
        </div>

        <div className="bench_config_block">
          <h5 className="bench_config_head">
            Competitors <span className="span_head">(3 primary)</span>
          </h5>
          <div className="bench_config_list_block">
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>Tailored Chemical
                Products
              </p>
            </div>
            {/* <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>McKesson
              </p>
            </div> */}
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>AmerisourceBergen
              </p>
            </div>
          </div>
        </div>

        <div className="bench_config_block">
          <h5 className="bench_config_head">
            Categories <span className="span_head">(3 selected)</span>
          </h5>
          <div className="bench_config_list_block">
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>📊 Technology
                Capabilities
              </p>
            </div>
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>📈 Market Share
              </p>
            </div>
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>🧑‍💻 User Experience
              </p>
            </div>
          </div>
        </div>

        <div className="bench_config_block">
          <h5 className="bench_config_head">Dimensions</h5>
          <div className="bench_config_list_block">
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>🗂️ 15 total analysis
                areas
              </p>
            </div>
          </div>
        </div>

        <div className="bench_config_block">
          <h5 className="bench_config_head">Estimated Analysis Time</h5>
          <div className="bench_config_list_block">
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>⏱️ 22 - 28 minutes
              </p>
            </div>
          </div>
        </div>

        <div className="bench_config_block">
          <h5 className="bench_config_head">Expected Sources:</h5>
          <div className="bench_config_list_block">
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>📄 1,200+ documents
              </p>
            </div>
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>🌐 800+ web pages
              </p>
            </div>
            <div className="bench_list">
              <p className="bench_list_text">
                <span className="bench_list_img"></span>📊 150+ reports
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h5 className="custom_lable">Benchmark Name</h5>
        <input
          type="text"
          className="form-control custom_input_text"
          placeholder="Standard Processing (20 - 30 min)"
        />
      </div>
      <div className="mt-3">
        <h5 className="custom_lable">Analysis Priority</h5>
        <select className="form-select mb-3 custom_input_text">
          <option value="">Standard Processing (20 - 30 min)</option>
          <option value="Medical Distribution">Medical Distribution</option>
          <option value="Diagnostics">Diagnostics</option>
        </select>
      </div>
      <div className="mt-4">
        <button
          className="btn btn-secondary me-2 previous_btn_wz"
          onClick={onPrev}
        >
          <FeatherIcon.ChevronLeft className="prev_feather" /> Previous
        </button>
        <button
          className="btn btn-success submit_btn_wz"
          onClick={handleSubmit}
        >
          Start Analysis{" "}
          <img
            src="/img/submit_btn.png"
            alt="image"
            className="company_filter_icon"
            width="16"
          />
        </button>
      </div>
    </div>
  );
};

export default ReviewSubmit;
